export default "__VITE_ASSET__DdyahQY9__"